const Shimmer = () => {
  return (
    <div className=" flex flex-wrap justify-between mx-8 my-12">
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4 w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4 w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className="m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
      <div className=" m-4 p-4  w-[220px] h-[430px] bg-slate-200"></div>
    </div>
  );
};
export default Shimmer;
